import React, { useMemo } from 'react'
import { Card } from '../../../../../../shared/card/card'
import { FormSimple } from '../../../../../../shared/form-simple/form'
import { FormSimpleSubmitEdit } from '../../../../../../shared/form-simple/form-submit'
import { useApiFormLogin } from '../../../../../../api-new/state/content'
import { FormSimpleHiddenNumber } from '../../../../../../shared/form-simple/form-hidden-number'
import { FormSimplePassword } from '../../../../../../shared/form-simple/form-password'

export const LoginPassword = ({ loginID }) => {
  const apiFormLogin = useApiFormLogin()

  // A refusal is shown by FormSimple (the layout's alert, with its reference)
  // and the password typed stays; it used to be swallowed here.
  const handleSubmit = async data => {
    await apiFormLogin.put(`${loginID}/password`, data)
    apiFormLogin.init()
  }

  const state = useMemo(
    () => {
      return { loginID: loginID, password: '' }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [apiFormLogin]
  )

  return (
    <React.Fragment>
      <Card title="password">
        <FormSimple state={state} onSubmit={handleSubmit}>
          <FormSimpleHiddenNumber name="loginID" />
          <FormSimplePassword name="password" />
          <FormSimpleSubmitEdit />
        </FormSimple>
      </Card>
    </React.Fragment>
  )
}
